/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { MagazineCollection } from "../issue-landing-page";
import "../issue-landing-page/issue-landing-page.m.css";
import { MagazineEditions } from "@quintype/arrow";

export const MagazineLandingPage = ({ data = {}, config = {} }) => {
  const { rows: magazineRows = [], pageSetting = {} } = get(
    config,
    ["pagebuilder-config", "magazine", "magazine-landing"],
    {}
  );
  if (!magazineRows.length) return <div styleName="info-message">Magazine configuration is missing.</div>;

  const firstEditionCollection = get(data, ["firstEditionCollection", "collection"], {});
  const { otherEditions = [], magazineSlug = "", magazineTitle = "", magazineDescription = "" } = data;

  return (
    <>
      {magazineRows.map(row => {
        const { name, layout, config } = row;
        switch (name) {
          case "headerEdition":
            const collection = {
              "associated-metadata": {
                config: {
                  pageDescription: magazineDescription,
                  ...config,
                  pageTitle: magazineTitle,
                  enableBorder: true,
                  customUrlPath: `/subscription?group=${magazineSlug}`
                },
                layout: layout
              }
            };
            return <MagazineCollection key={name} collection={collection} layout={layout} metadata={{}} />;
          case "otherEditions":
            if (otherEditions.length) {
              return (
                <div styleName="editions-wrapper">
                  <MagazineEditions
                    key={name}
                    collection={otherEditions}
                    config={{
                      ...{ theme: pageSetting.bgColor },
                      ...config,
                      magazineSlug,
                      isArchivePage: true
                    }}
                    showLoadmore={config.showButton}
                  />
                </div>
              );
            }
            break;
          case "topStories":
            return (
              <MagazineCollection
                key={name}
                collection={firstEditionCollection}
                layout={layout}
                metadata={{ ...config, navigate: false, magazineSlug }}
              />
            );
        }
      })}
    </>
  );
};

MagazineLandingPage.propTypes = {
  data: PropTypes.shape({
    otherEditions: PropTypes.array,
    firstEditionCollection: PropTypes.shape({
      collection: PropTypes.object
    })
  }),
  config: PropTypes.shape({
    "pagebuilder-config": PropTypes.shape({
      magazine: PropTypes.shape({
        rows: PropTypes.array,
        pageSetting: PropTypes.object
      })
    })
  })
};
